var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtGivingCollege = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 132,
    viewBox: "0 0 219 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.141 58.04c.211-2.53 1.076-4.557 2.093-5.323a3.618 3.618 0 0 1-2.758-3.507 3.62 3.62 0 0 1 2.628-3.473V26.22l1.99-.76v20.276a3.62 3.62 0 0 1 2.628 3.473c0 1.7-1.173 3.118-2.758 3.507 1.022.766 1.882 2.794 2.093 5.324l1.541 21.937c-.043.006-.087.011-.13.022-1.216-1.046-2.73-1.672-4.374-1.672-1.644 0-3.158.626-4.375 1.672-.043-.005-.086-.01-.13-.022l1.541-21.937h.011z",
    fill: "#F6C760",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BA7547",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.464 10.876-.751 4.617a2.535 2.535 0 0 0 2.443 2.775 2.536 2.536 0 0 0 2.622-2.447l.197-5.83c.03-.9-.705-1.645-1.612-1.625a2.996 2.996 0 0 0-2.899 2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.385 22.49 2.12-6.77a2.138 2.138 0 0 1 2.676-1.403l.922.287a2.138 2.138 0 0 1 1.405 2.68l-2.12 6.771a2.138 2.138 0 0 1-2.676 1.403l-.922-.287a2.138 2.138 0 0 1-1.405-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.11 34.852 5.024-11.782a2.354 2.354 0 0 1 3.085-1.244l.489.207a2.354 2.354 0 0 1 1.247 3.091l-5.024 11.782a2.354 2.354 0 0 1-3.084 1.245l-.49-.208a2.354 2.354 0 0 1-1.246-3.091z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m109.74 15.466-6.312-3.842a2.813 2.813 0 0 1-.936-3.872l.184-.3a2.813 2.813 0 0 1 3.861-.934l6.312 3.842a2.813 2.813 0 0 1 .936 3.872l-.185.3a2.813 2.813 0 0 1-3.86.934z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.213 11.468 5.35.355a2.895 2.895 0 0 0 2.902-3.066 2.897 2.897 0 0 0-3.07-2.711l-6.672.405a1.8 1.8 0 0 0-1.683 2 3.422 3.422 0 0 0 3.176 3.017h-.003zM111.756 11.062l.34-.13a2.813 2.813 0 0 1 3.624 1.633l5.109 13.444a2.813 2.813 0 0 1-1.635 3.63l-.341.129a2.813 2.813 0 0 1-3.623-1.632l-5.11-13.444a2.813 2.813 0 0 1 1.636-3.63z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.901 12.417-4.236-5.535a2.621 2.621 0 0 1 .497-3.68l.292-.223a2.64 2.64 0 0 1 3.691.495l4.236 5.535a2.621 2.621 0 0 1-.496 3.68l-.293.223a2.64 2.64 0 0 1-3.69-.495z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.158 4.985 4.569 2.13a2.728 2.728 0 0 0 3.592-1.703 2.718 2.718 0 0 0-1.765-3.419l-5.99-1.912a1.697 1.697 0 0 0-2.158 1.182 3.21 3.21 0 0 0 1.752 3.725v-.003zM115.384 25.399l.12-13.56a2.631 2.631 0 0 1 2.656-2.603l.367.003a2.63 2.63 0 0 1 2.611 2.649l-.119 13.56a2.631 2.631 0 0 1-2.656 2.602l-.368-.003a2.63 2.63 0 0 1-2.61-2.648zM146.48 64.874l-8.518 14.715-30.92-21.986 9.61-14.955z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.003 18.7 10.964 15.131c1.27 1.169 3.305-4.306 4.723-5.838 1.417-1.532 1.536-3.722.265-4.89l-10.817-9.949c-1.271-1.168-3.452-.876-4.87.656-1.417 1.532-1.536 3.722-.265 4.89z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.47 17.416 9.493-4.996a3.09 3.09 0 0 1 4.163 1.283l.048.09a3.07 3.07 0 0 1-1.287 4.15l-9.492 4.996a3.09 3.09 0 0 1-4.164-1.282l-.047-.09a3.07 3.07 0 0 1 1.286-4.151z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    fillRule: "nonzero",
    d: "m139.764 58.876-12.356 15.271L201.357 132 219 111.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.59 24.828 5.427-1.4a3.022 3.022 0 0 0 1.87-3.995 3.038 3.038 0 0 0-3.943-1.686l-6.492 2.587a1.879 1.879 0 0 0-1.011 2.537 3.585 3.585 0 0 0 4.145 1.957h.003z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 27c-4.397-6.375-17.509-11-33-11s-28.603 4.625-33 11c7.303-4.142 19.358-6.853 33-6.853S78.697 22.858 86 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.449 49.995V35.617l20.551-8.5L53.5 5 0 27.123l20.551 8.498v13.503c9.046-3.349 20.008-5.306 31.827-5.306 12.813 0 24.623 2.307 34.07 6.182v-.005zM53.5 22.605c15.467 0 28.563 4.518 32.949 10.743-7.292-4.045-19.328-6.693-32.949-6.693-13.621 0-25.657 2.648-32.949 6.693 4.39-6.225 17.482-10.742 32.949-10.742z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56 26.632c3.07 1.538 3.786 5.949 5.519 8.379.983 1.38 3.357.647 4.546.308.002 0 .008-.022.01-.022 3.803-1.815 5.188-1.215 6.832-5.615.277-.738.805-2.196 1.114-2.986 2.877-1.22 5.773-1.912 8.63-3.331 1.065 4.741 1.963 6.22 2.892 11.66.928 5.438-.235 14.993-1.302 22.374-1.067 7.378-17.5 1.565-19.735-2.631-2.236-4.196-2.3-4.442-3.772-8.059-.614-1.502-.647-1.763-1.156-3.389a60.8 60.8 0 0 0-2.268-2.763c-2.341-2.65-3.792-7.478-5.843-9.41-1.663-1.567-3.109-3.008-1.973-4.724 1.136-1.717 5.082-.504 6.506.21z",
    fill: "#BA7547",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtGivingCollege);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-giving-college.0f21d74431e89ee1a98fbd58be07ab5a.svg";